import { Entity } from '@inter-ikea-core/core';
import { COMPONENT_IDS } from '@inter-ikea-storagetwo/range';
import { getGuestConnections } from '@inter-ikea-storagetwo/range/dist/functions/componentGetters';
import { UPRIGHT_TO_MOUNTING_RAIL_LEFT } from '@inter-ikea-storagetwo/boaxel/dist/constants/connectorKeys';
import { CONNECTOR_TO_SIZE_MAP } from '../utils/connectorUtils';

const getUprights = (entities: Entity[]) =>
  entities.filter(e => e.hasComponent(COMPONENT_IDS.UPRIGHT_COMPONENT));

export const getExistingSectionWidths = (entities: Entity[]) => {
  const uprights = getUprights(entities);

  const rightUprightConnections = uprights
    .flatMap(u => getGuestConnections(u))
    .filter(con => con.hostConnectorKey !== UPRIGHT_TO_MOUNTING_RAIL_LEFT);

  return rightUprightConnections.reduce((acc: number[], curr) => {
    const width = CONNECTOR_TO_SIZE_MAP.get(curr.hostConnectorKey);
    if (!width || acc.includes(width)) return acc;
    acc.push(width);
    return acc;
  }, []);
};
